import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Landing from '../pages/Landing';
import Why from '../pages/Why';
import Platform from '../pages/Platform';
import Solutions from '../pages/Solutions';
import Pricing from '../pages/Pricing';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import Payment from '../pages/Payment';
import PaymentSuccess from '../pages/PaymentSuccess';
import PaymentCancel from '../pages/PaymentCancel';
import SignupSuccess from '../pages/SignupSuccess';
import ContactSales from '../pages/ContactSales';
import MainDomainNav from './MainDomainNav';
import { useTenant } from '../context/TenantContext';

/**
 * Routes for main domain (crudexpert.com)
 * Shows marketing pages and public access
 */
const MainDomainRoutes: React.FC = () => {
  const { isMainDomain } = useTenant();

  // If not on main domain, redirect to tenant app
  if (!isMainDomain) {
    return null; // Will be handled by TenantDomainRoutes
  }

  return (
    <Box>
      <MainDomainNav />
      <Box sx={{ pt: '64px' }}> {/* Add padding-top to account for fixed header */}
        <Routes>
        <Route path="/" element={<Why />} />
        <Route path="/why" element={<Why />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/get-started" element={<Register />} />
        <Route path="/success" element={<SignupSuccess />} />
        <Route path="/contact-sales" element={<ContactSales />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Box>
    </Box>
  );
};

export default MainDomainRoutes;

